module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./PhaseBalance.js"));
	}, "PhaseBalance");
}